import { Call } from "@ravalmatic/bridge-engine/core";
import { BiddingRow } from "./BiddingRow";

export class BiddingGrid extends Phaser.GameObjects.Container {

    private static readonly ROW_SPACING = 58;

    private readonly rows: BiddingRow[];

    constructor(scene: Phaser.Scene, onSelected: (call: Call) => void) {

        super(scene);

        this.setPosition(0, -200);

        this.rows = Array.from({ length: 7 }, (_, index) => {
            const row = new BiddingRow(scene, index + 1, onSelected);
            row.setPosition(0, index * BiddingGrid.ROW_SPACING);
            return row;
        });
        this.add(this.rows);
    }

    public refresh(legalCalls: readonly Call[], selectedCall: Call | null, enabled: boolean): void {

        this.rows.forEach(row => row.refresh(legalCalls, selectedCall, enabled));
    }
}
